module.exports = __webpack_public_path__ + "static/media/Assurant.9dccb5a6.svg";